var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.spinner,"spinner-variant":"primary"}},[_c('salidasForm',{attrs:{"salida":_vm.salidaData,"salidaSubmit":"Crear Salida"},on:{"processSalida":_vm.agregarSalidas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }